var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-header"},[_c('h2',{staticClass:"heading--style"},[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.descripion)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }